<app-view-item *ngIf="readonly" [text]="selected?.code" [borderless]="borderless"></app-view-item>

<div nz-row *ngIf="!readonly" nzAlign="middle" nzGutter="0">
  <div nz-col nzFlex="auto">
    <nz-select *ngIf="!readonly" 
        nzShowSearch 
        nzServerSearch 
        [nzAllowClear]="true" 
        [nzBackdrop]="addBackdrop"
        [nzFilterOption]="nzFilterOption"
        (nzOnSearch)="search($event)" 
        (nzOpenChange)="search('')"
        (nzScrollToBottom)="loadMore()"
        [nzCustomTemplate]="displayTpl" 
        [nzDropdownRender]="addTpl" 
        [(ngModel)]="value"
        (ngModelChange)="valueChanged($event)" 
        [nzDropdownMatchSelectWidth]="false"
        [nzBorderless]="borderless"
        nzDropdownClassName="dropdownSelect"
        class="width-100">
      <ng-template #displayTpl let-selected>
        {{ selected.nzLabel }}
      </ng-template>
      <ng-container *ngFor="let item of list">
        <nz-option *ngIf="!searching" [nzValue]="getValue(item)" [nzLabel]="item.code" nzCustomContent>
          <app-bir-select-item [bir]="item"></app-bir-select-item>
        </nz-option>
      </ng-container>
      <ng-template #addTpl>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" (click)="addNew()">
            <span nz-icon nzType="plus"></span>
            Add New
          </button>
        </div>
      </ng-template>
    </nz-select>
  </div>
</div>

<app-bir-edit-modal (selectBir)="selectBir($event)" [isGlVoucher]="true"></app-bir-edit-modal>
